<template>

    <p class="form-error error" v-if="content">
        <span v-for="c in content">
            {{ c }}<br>
        </span>
    </p>

</template>

<script>

    export default {

        props: [
            'content'
        ]

    }

</script>

<style>

    .form-error {
        margin: 0 0 .5rem;
    }

</style>